function getURLParams() {
  const params = {};
  new URLSearchParams(window.location.search).forEach((value, key) => {
    params[key] = value;
  });
  return params;
}

function atualizarTotal() {
  const btnContinuar = document.getElementById('btn-continuar');
  if (!btnContinuar) return;
}

document.addEventListener('DOMContentLoaded', function() {
  atualizarTotal();

  document.querySelectorAll('.extra-item input[type="number"]').forEach(input => {
    input.addEventListener('input', atualizarTotal);
  });
});

(function() {
  let cepValidoPecas = false;

  const cepsPermitidosPecas = [
    '70670011','70670012','70670013','70670014','70670015','70670016','70670017','70670101',
    '70670102','70670103','70670104','70670105','70670106','70670107','70670108','70670109',
    '70670110','70670111','70670201','70670202','70670203','70670204','70670205','70670206',
    '70670207','70670208','70670209','70670210','70670211','70670212','70673022','70673024',
    '70673026','70673028','70673030','70673032','70673034','70673036','70673038','70673040',
    '70673042','70673044','70673048','70673052','70673054','70673056','70673058','70673060',
    '70673101','70673102','70673103','70673104','70673105','70673106','70673107','70673108',
    '70673109','70673110','70673201','70673202','70673203','70673204','70673205','70673206',
    '70673207','70673208','70673209','70673210','70673211','70674037','70674013','70674016',
    '70674019','70674022','70674028','70674031','70674034','70674040','70674043','70674046',
    '70674049','70674052','70674055','70674058','70674061','70674064','70674070','70674073',
    '70674076','70674079','70674082','70674088'
  ];

  const cepInput = document.getElementById('cep-pecas');
  const mensagem = document.getElementById('mensagem-cidade');
  const btnContinuar = document.getElementById('btn-continuar');

  function setContinuarHabilitado(habilitado) {
    if (!btnContinuar) return;
    btnContinuar.disabled = !habilitado;
  }

  if (cepInput) {
    cepInput.addEventListener('blur', function() {
      const cep = this.value.replace(/\D/g, '');

      if (cep.length !== 8) {
        if (mensagem) {
          mensagem.style.display = 'block';
          mensagem.innerText = 'CEP inválido.';
        }
        cepValidoPecas = false;
        setContinuarHabilitado(false);
        return;
      }

      fetch(`https://viacep.com.br/ws/${cep}/json/`)
        .then(r => r.json())
        .then(data => {
          if (data.erro) {
            alert('CEP não encontrado.');
            cepValidoPecas = false;
            setContinuarHabilitado(false);
            return;
          }

          document.getElementById('logradouro-pecas').value = data.logradouro || '';
          document.getElementById('bairro-pecas').value = data.bairro || '';
          document.getElementById('cidade-pecas').value = data.localidade || '';
          document.getElementById('estado-pecas').value = data.uf || '';

          if (cepsPermitidosPecas.includes(cep)) {
            if (mensagem) mensagem.style.display = 'none';
            cepValidoPecas = true;
            setContinuarHabilitado(true);
          } else {
            if (mensagem) {
              mensagem.style.display = 'block';
              mensagem.innerText = 'Infelizmente ainda não atendemos esta localidade.';
            }
            cepValidoPecas = false;
            setContinuarHabilitado(false);
          }
        })
        .catch(() => {
          alert('Erro ao buscar CEP.');
          cepValidoPecas = false;
          setContinuarHabilitado(false);
        });
    });
  }

  function somarItem(map, variantId, quantidade) {
    const id = String(variantId || '').trim();
    const qtd = parseInt(quantidade, 10) || 0;

    if (!id || id === 'undefined' || id === 'null' || qtd <= 0) return;

    map.set(id, (map.get(id) || 0) + qtd);
  }

  function coletarItensSelecionados() {
    const itensPorVariant = new Map();
    let totalPecas = 0;

    document.querySelectorAll('#lf-lista .extra-item input[type="number"]').forEach(input => {
      const quantidade = parseInt(input.value, 10) || 0;
      const variantId =
        input.getAttribute('data-v') ||
        input.getAttribute('data-variant') ||
        input.dataset.v ||
        input.dataset.variant;

      if (quantidade > 0) totalPecas += quantidade;
      somarItem(itensPorVariant, variantId, quantidade);
    });

    if (Array.isArray(window.LF_EXTRAS_VARIANTS)) {
      window.LF_EXTRAS_VARIANTS.forEach(extra => {
        const quantidade = parseInt(extra.qty, 10) || 0;
        const variantId =
          extra.variantId ||
          extra.variant ||
          extra.id;
        const id = String(variantId || '').trim();

        if (!id || itensPorVariant.has(id)) return;
        if (quantidade > 0) totalPecas += quantidade;
        somarItem(itensPorVariant, variantId, quantidade);
      });
    }

    const planoVariant = window.LF_PLANO_VARIANT ? String(window.LF_PLANO_VARIANT) : '';
    if (planoVariant) {
      somarItem(itensPorVariant, planoVariant, 1);
    }

    return {
      items: Array.from(itensPorVariant.entries()).map(([id, quantity]) => ({
        id: parseInt(id, 10),
        quantity: quantity
      })),
      totalPecas: totalPecas,
      temPlano: !!planoVariant
    };
  }

  function finalizarCheckout(items, attributes) {
    return fetch('/cart/clear.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' }
    })
      .then(() => fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items: items })
      }))
      .then(r => {
        if (!r.ok) throw new Error('Erro ao adicionar itens ao carrinho.');

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ attributes: attributes })
        });
      })
      .then(r => {
        if (!r.ok) throw new Error('Erro ao atualizar dados de entrega.');
        window.location.href = '/checkout';
      });
  }

  if (btnContinuar) {
    btnContinuar.addEventListener('click', function(e) {
      e.preventDefault();

      if (!cepValidoPecas) {
        alert('Informe um CEP válido antes de continuar.');
        return;
      }

      const entregaEl = document.querySelector('[name="properties[Horário limite para entrega]"], [name="properties[HorÃ¡rio limite para entrega]"]');
      const coletaEl = document.querySelector('[name="properties[Horário limite para coleta]"], [name="properties[HorÃ¡rio limite para coleta]"]');

      const horarioEntrega = entregaEl ? entregaEl.value : '';
      if (!horarioEntrega || horarioEntrega < '07:30' || horarioEntrega > '08:30') {
        alert('Selecione um horário entre 07:30 e 08:30 para entrega.');
        return;
      }

      const horarioColeta = coletaEl ? coletaEl.value : '';
      if (!horarioColeta || horarioColeta < '08:30' || horarioColeta > '10:30') {
        alert('Selecione um horário entre 08:30 e 10:30 para a coleta.');
        return;
      }

      const selecionados = coletarItensSelecionados();

      if (selecionados.items.length === 0) {
        alert('Selecione ao menos um produto.');
        return;
      }

      const attributes = {
        'CEP:': cepInput.value,
        'Logradouro:': document.getElementById('logradouro-pecas').value,
        'Bairro:': document.getElementById('bairro-pecas').value,
        'Cidade:': document.getElementById('cidade-pecas').value,
        'Estado:': document.getElementById('estado-pecas').value,
        'Dia da semana da coleta': document.getElementById('dia-retirada-pecas').value,
        'Horário limite para coleta': horarioColeta,
        'Horário limite para entrega': horarioEntrega
      };

      btnContinuar.disabled = true;
      btnContinuar.dataset.originalText = btnContinuar.dataset.originalText || btnContinuar.textContent;
      btnContinuar.textContent = 'Enviando...';

      finalizarCheckout(selecionados.items, attributes)
        .catch(err => {
          alert(err.message || 'Erro ao finalizar. Tente novamente.');
          btnContinuar.disabled = false;
          btnContinuar.textContent = btnContinuar.dataset.originalText || 'Continuar';
        });
    });
  }
})();
